<template>
  <div v-if="template" class="instype-result-wrap">
    <fast-liability
      :temp="template"
      :data="descData"
      :profit-btn="propProfit"
      :company-list="companyList"
      @disShow="_fetchDisData"
    />
  </div>
</template>

<script>
import ToggleTemp from 'components/toggleTemp/toggleTemp'
import FastLiability from 'components/liability/fastLiability'

export default {
  name: 'InsResult',
  components: {
    ToggleTemp,
    FastLiability,
  },
  props: {
    template: {
      type: Object,
      default() {
        return {}
      },
    },
    companyList: {
      type: Array,
      default() {
        return []
      },
    },
    propProfit: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      descTemplate: '',
      descData: '',
      disData: [],
      disActive: 0,
      disVisible: false,
      disHeader: '病种详情',
      disLink: '',
    }
  },
  watch: {
    template(newTemplate) {
      this.pageInit(newTemplate)
    },
  },
  created() {
    this.pageInit()
  },
  methods: {
    // 初始化
    pageInit(temp = this.template) {
      if (temp) {
        this.descTemplate = {
          planLib: temp.libData,
          name: temp.name,
          insuranceTypeId: temp.insuranceTypeId,
          // diff: temp.diff,
          // diffname: temp.diffname,
          accountMap: temp.accountMap,
          insuredAge: temp.insuredAge,
          trades: temp.trades,
        }
        this.descData = temp.calData
      }
    },
    _fetchDisData(path) {
      let { pidx, idx } = path

      let liabilities =
        this.descTemplate.liabilities[pidx].insuranceLiabilities[idx]
          .liabilities
      let diseaseAry = []
      liabilities.forEach((liab) => {
        let { title, link, detail } = liab.disease
        title &&
          diseaseAry.push({
            title,
            link,
            detail,
          })
      })

      this.disData = this._normalizeDisText(diseaseAry)
      this.disVisible = true
    },
    _closeDisDialog() {
      this.disVisible = false
    },
    _normalizeDisText(list) {
      let ret = []
      list.forEach((dis, index) => {
        let detail = dis.detail
        detail = `${detail.replace(
          /\d+[\、|\.]/g,
          '</p><p><span>$&</span>'
        )}</p>`
        detail = detail.replace(/<\/p>/, '')
        ret.push({
          fType: dis.fType,
          detail: detail,
          title: dis.title,
        })
      })
      return ret
    },
  },
}
</script>